module.exports = __webpack_public_path__ + "img/仿真恐龙背包.4d747077.jpg";